import { useTranslation } from "react-i18next";
import { changeLanguage } from "src/i18n";

// Порядок сознательный: сначала языки региона, потом язык гостей.
// lang="" на каждой кнопке — чтобы название языка читалось своим голосом
// даже когда сайт открыт на другом языке.
export const LANGUAGES = [
  { code: "kk", label: "Қазақша", short: "ҚАЗ" },
  { code: "ru", label: "Русский", short: "РУС" },
  { code: "en", label: "English", short: "ENG" },
];

/**
 * Переключатель языков.
 *  variant="full"    — полные названия, для футера
 *  variant="compact" — короткие коды, для шапки и плавающей шапки
 *
 * Раньше компонент сам читал localStorage в useEffect и звал changeLanguage
 * при монтировании. Из-за этого язык применялся только после того, как
 * домонтируется футер: страница успевала мелькнуть на английском. Чтение
 * сохранённого языка переехало в src/i18n.js, до первого рендера.
 */
export const Languages = ({ variant = "full", className = "" }) => {
  const { t, i18n } = useTranslation();
  const current = i18n.language;
  const compact = variant === "compact";

  return (
    <nav
      aria-label={t("header.languageSwitcher")}
      className={`flex flex-wrap items-center ${
        compact ? "gap-x-0.5" : "justify-center md:justify-start gap-x-1 sm:gap-x-2"
      } gap-y-1 ${className}`}
    >
      {LANGUAGES.map((lng) => {
        const active = current === lng.code;
        return (
          <button
            key={lng.code}
            type="button"
            lang={lng.code}
            onClick={() => changeLanguage(lng.code)}
            // aria-current вместо «просто золотого цвета»: выбранный язык
            // должен быть слышен в скринридере, а не только виден
            aria-current={active ? "true" : undefined}
            className={`
              inline-flex items-center justify-center rounded-md
              min-h-[44px] ${compact ? "min-w-[44px] px-2 text-xs" : "px-3 text-base sm:text-lg"}
              font-bold transition-colors
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kj-gold
              focus-visible:ring-offset-2 focus-visible:ring-offset-kj-dark
              ${
                active
                  ? "text-kj-gold underline decoration-2 underline-offset-4"
                  : "text-kj-ink/80 hover:text-kj-ink hover:bg-white/5"
              }
            `}
          >
            {compact ? lng.short : lng.label}
          </button>
        );
      })}
    </nav>
  );
};

export default Languages;
